export const GAM_SOURCE = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js'
